import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';
import './Hero.css';

function Hero() {
  const isMobile = useMediaQuery({ maxWidth: 600 });

  return (
    <section className="hero">
      <div className="hero-content">
        {isMobile && (
          <div className="hero-social">
            <a href="https://linkedin.com/soundtrackarchive" className="hero-social-link" aria-label="LinkedIn" target="_blank" rel="noreferrer">
              <FaLinkedin className="hero-social-icon" />
            </a>
            <a href="https://facebook.com/soundtrackarchive" className="hero-social-link" aria-label="Facebook" target="_blank" rel="noreferrer">
              <FaFacebook className="hero-social-icon" />
            </a>
            <a href="https://instagram.com/soundtrackarchive" className="hero-social-link" aria-label="Instagram" target="_blank" rel="noreferrer">
              <FaInstagram className="hero-social-icon" />
            </a>
          </div>
        )}
        <h1 className="hero-latest">LATEST</h1>
        <div className="hero-sections">
          <div className="hero-section hero-syncspace">
            <img src="/syncspace.png" alt="SyncSpace" className="hero-syncspace-image" />
          </div>
          <div className="hero-section hero-latest-section">
            <a href="https://open.spotify.com/playlist/6r4F3h9q2Wsh7WlXRHPnub" target="_blank" rel="noreferrer" className="hero-spotify-link">
              <img src="/syncs.png" alt="Spotify Playlist" className="hero-syncs" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
